import { types, Instance, getParent } from 'mobx-state-tree'
import { Sideview, Orbitview } from 'src/api/misc/View/Sideview'
import {
  contentEdge,
  coverEdge,
  elementEdge,
  project
} from 'src/constants/typenames'
import { orbit } from 'src/constants/sides'
import { SelectedItemReference } from 'src/api/stores/Editor/SelectedItemReference'
import {
  ISelectedItem,
  IEditorSideviewBase,
  IEditorSideView,
  IEditorOrbitview,
  ICurrentView
} from './types'

// @ts-ignore
const EditorSideviewBase: IEditorSideviewBase = types
  .model({
    selectedItem: SelectedItemReference
  })
  .actions((self) => ({
    focus() {
      if (!!self.selectedItem) {
        self.selectedItem?.__typename !== project &&
          self.selectedItem?.focus?.()
        if (self.selectedItem?.__typename === elementEdge) {
          self.selectedItem?.reference.value?.focusReferencePoint({
            side: self.selectedItem.side,
            referencePoint:
              self.selectedItem.properties.parentReferencePoint.value
          })
        }
      }
    },
    blur() {
      if (!!self.selectedItem) {
        self.selectedItem?.blur?.()
        if (self.selectedItem?.__typename === elementEdge) {
          self.selectedItem?.reference.value?.blur?.()
        }
      }
    }
  }))
  .actions((self) => ({
    selectItem(item: ISelectedItem) {
      if (self.selectedItem !== null && self.selectedItem?.id !== item.id) {
        self.blur()
      }
      self.selectedItem = item.id as $LibBugAny
      if (item.__typename !== elementEdge) self?.enablePan?.()

      self.focus()
    },
    unselectItem() {
      self.blur()
      self.selectedItem = null
    }
  }))

export const EditorSideview: IEditorSideView = types.compose(
  EditorSideviewBase,
  Sideview
)
export const EditorOrbitview: IEditorOrbitview = types.compose(
  EditorSideviewBase,
  Orbitview
)

export const CurrentView: ICurrentView = types.reference(
  types.union(EditorSideview, EditorOrbitview),
  {
    get(identifier /* string */, parent: any /* Editor */) {
      return parent.sideviews.get(identifier)
    },
    set(sideview /*  Project */) {
      return sideview.side
    }
  }
)
